import React from 'react';

const BlockchainConcept = (props) => {
  return (
    <div>
      <p className="step-p">A blockchain has a list of blocks. </p>

      <p className="step-p">
        It starts with a single block, called the <b>genesis block</b>.
      </p>
    </div>
  );
};

export default BlockchainConcept;


// WEBPACK FOOTER //
// ./src/steps/blockchain/blockchain-concept.js